


export const DISCORD_URL = "https://discord.gg/TVCTQa3WUR"